export const messages = {
  nl: {
    'create new project': 'Maak nieuw project aan',
    assets: 'Panden',
    asset: 'Pand',
    certificates: 'Certificaten',
    clients: 'Klanten',
    assetmanagement: 'Panden beheer',
    complexes: 'Complexen',
    beperking: 'Beperking',
    'beperkingen en uitsluitingen': 'Beperkingen en uitsluitingen',
    asset_templates: 'Ruimte sjabloon',
    'asset templates': 'Ruimte sjabloon',
    documents: 'Documenten',
    date: 'Datum',
    deskresearch: 'Deskresearch',
    eind: 'Eind',
    info: 'Info',
    interviews: 'Interviews',
    inventories: 'Inventarisaties',
    inventory: 'Inventarisatie',
    laboratories: 'Laboratoria',
    limitation: 'Uitsluiting',
    limitations: 'Uitsluitingen',
    list: 'List',
    loading: 'laden',
    name: 'Naam',
    account: 'Account',
    capabilities: 'Capabilities',
    uitrusting: 'Uitrusting',
    organisation: 'Organisatie',
    overview: 'Info',
    photos: "Foto's",
    plans: 'Plattegronden',
    plan: 'Plattegrond',
    project: 'Project',
    projects: 'Projecten',
    'postal code': 'postcode',
    register: 'Registreer',
    reports: 'Rapporten',
    samples: 'Monsters',
    'source locations': 'Bronlocaties',
    sources: 'Bronnen',
    start: 'Start',
    survey: 'Onderzoek',
    surveys: 'Onderzoeken',
    users: 'Gebruikers',
    variables: 'Variabelen',
    vscp: 'VSCP',
    welcome: 'Welkom',
    resident: 'Bewoner',
    spaces: 'Ruimten',
    space: 'Ruimte',
    'year built': 'Bouwjaar',
    type: 'Type',
    apply: 'pas {0} toe',
    'pick file': 'Kies bestand',
    'part of': 'Is onderdeel van',
    submit: 'Submit',
    new: 'Nieuwe',
    contact: 'contact',
    bezoek_plaats: 'bezoek_plaats',
    bezoek_straat: 'bezoek_straat',
    bezoek_postcode: 'bezoek_postcode',
    bezoek_land: 'bezoek_land',
    post_plaats: 'post_plaats',
    post_straat: 'post_straat',
    post_postcode: 'post_postcode',
    post_land: 'post_land',
    statutaire_naam: 'statutaire_naam',
    vestiging: 'vestiging',
    btw_nummer: 'btw_nummer',
    kvk_nummer: 'kvk_nummer',
    ondernemings_nummer: 'ondernemings_nummer',
    kvk_vestigings_nummer: 'kvk_vestigings_nummer',
    sca_code: 'sca_code',
    other: 'Overig',
    signature: 'handtekening',
    observations: 'Waarnemingen',
    surveyInfo: 'Info',
    surveyReports: 'Rapporten'
  },
  fr: {
    projects: 'Projets',
    project: 'Projet',
    'create new project': 'Créer un nouveau projet',
    name: 'Nom',
    date: 'Date',
    assets: 'Assets',
    asset: 'Asset',
    start: 'Start',
    eind: 'Fin',
    welcome: 'Bienvenu',
    overview: 'Info',
    survey: 'Recherche',
    surveys: 'Recherches',
    'source locations': 'Emplacements source',
    sources: 'Sources',
    samples: 'Samples',
    inventory: 'Inventory',
    inventories: 'Inventarisaties',
    info: 'Info',
    list: 'List',
    users: 'Users',
    clients: 'Clients',
    laboratories: 'Laboratories',
    certificates: 'Laboratoria en certificaten',
    account: 'Account',
    capabilities: 'Capabilities',
    uitrusting: 'Gear',
    organisation: 'Organisation',
    assetmanagement: 'Asset Management',
    complexes: 'Complexes',
    interviews: 'Interviews',
    variables: 'Variables',
    deskresearch: 'Deskresearch',
    reports: 'Rapporten',
    plans: 'Plans',
    beperking: 'Beperking',
    'beperkingen en uitsluitingen': 'Beperkingen en uitsluitingen',
    vscp: 'VSCP',
    asset_templates: 'Asset Templates',
    observations: 'Observations'
  },
  en: {
    register: 'Register',
    'create new project': 'Create a new project',
    projects: 'Projects',
    project: 'Project',
    name: 'Name',
    assets: 'Assets',
    asset: 'Asset',
    date: 'Date',
    start: 'Start',
    eind: 'Eind',
    welcome: 'Welcome',
    overview: 'Info',
    survey: 'Survey',
    surveys: 'Surveys',
    'source locations': 'Source locations',
    sources: 'Sources',
    samples: 'Samples',
    inventory: 'Inventory',
    inventories: 'Inventories',
    info: 'Info',
    list: 'List',
    users: 'Users',
    clients: 'Clients',
    laboratories: 'Laboratories',
    certificates: 'Labs and Certificates',
    account: 'Account',
    capabilities: 'Capabilities',
    uitrusting: 'Gear',
    organisation: 'Organisation',
    assetmanagement: 'Asset Management',
    complexes: 'Complexes',
    interviews: 'Interviews',
    variables: 'Variables',
    deskresearch: 'Deskresearch',
    reports: 'Reports',
    plans: 'Plans',
    ruimte: 'Space',
    ruimtes: 'Spaces',
    fotos: 'Photos',
    vesselmanagement: 'Vessels',
    beperking: 'Limitation',
    'beperkingen en uitsluitingen': 'Limitations',
    vscp: 'VSCP',
    asset_templates: 'Asset Templates',
    observations: 'Observations'
  }
}
